// Environment configuration
export const config = {
  // API Configuration
  // When deployed, API is accessible via CloudFront at /api path
  // In development, use the local server or API Gateway URL directly
  apiUrl: (import.meta as any).env?.VITE_API_URL || '/api',

  // Webhook Configuration
  webhookBaseUrl: (import.meta as any).env?.VITE_WEBHOOK_BASE_URL || '',
  
  // Application Configuration
  appName: (import.meta as any).env?.VITE_APP_NAME || 'Collabo Bugyo Cloud',
  appVersion: (import.meta as any).env?.VITE_APP_VERSION || '0.0.1',
};

export default config;
